import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './common/themes';

function ThemeProvider({ children }: any) {
	return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

export default ThemeProvider;
